// prompts.<area>.<key>: the suggested questions (services/platform-agent/platformAgentSuggestions.js), sent as typed.
// {{dish}} is a dish on the restaurant's menu, {{amount}} an amount in its currency (both from the picker).
export default {
  title: 'Cześć {{first_name}}, w czym mogę pomóc w {{restaurant}}?',
  title_no_name: 'Cześć, czego potrzebujesz dla {{restaurant}}?',
  text: 'Odpowiem na pytania o {{restaurant}} i wprowadzę zmiany za Ciebie. Nic się nie zmieni, dopóki tego nie zatwierdzisz.',
  suggestions: 'Propozycje',
  prompts: {
    reports: {
      top_dishes: 'Jakie było 10 najpopularniejszych dań w zeszłym miesiącu?',
      sales_vs_last_month: 'Jak wypadła sprzedaż w porównaniu z zeszłym miesiącem?',
    },
    menu: {
      raise_dish_price: 'Podnieś cenę {{dish}} o {{amount}}',
      dish_sold_out: 'Oznacz {{dish}} jako wyprzedane',
      dishes_without_photo: 'Które dania nie mają zdjęcia?',
    },
    hours: {
      holiday_hours: 'Zmień nasze godziny otwarcia na 24 grudnia',
    },
    order_settings: {
      minimum_order: 'Podnieś minimalną wartość zamówienia do {{amount}}',
    },
    marketing: {
      promo_code: 'Utwórz kod rabatowy 10 % na ten weekend',
    },
    my_info: {
      phone_number: 'Zaktualizuj nasz numer telefonu',
    },
  },
};
